
import React, { useState, useEffect } from 'react';
import СitiesCloseBtn from '../../buttons/cities-close'
import axios from 'axios'


function Country(props) {

    const active = props.active
    const countryName = props.country
    const className = `country-item country-item_${countryName} ${active ? "" : 'non-active'}`
    const countObects = props.countObects

    const [citiesObects, setObjects] = useState([]);
    const [citiesOpen, setCitiesOpen] = useState(false);

    useEffect(() => {
        axios.get('https://thai.hub360.info/api/objects?parents=cities&categoryId=744&lang=ru')
            .then(function (response) {
                setObjects(response.data.items)
                console.log(response.data.items)
            })
    }, []);

    const openMenu = () => {
        if (!citiesOpen) {
            setCitiesOpen(true)
        }
    }

    const closeMenu = () => {
        setCitiesOpen(false)
    }

    return (
        <div onClick={openMenu} className={className}>
            <div className="country-item__count">{countObects} объектов</div>
            {citiesOpen &&
                <div className='country-item__cities'>
                    {citiesObects.map((item, index) => {
                        const link = `https://thai.hub360.info#!p=${item.itemId}-${item.alias}&s=pano${item.panoId}&lang=ru`;
                        return <a href={link} key={index}>{item.title}</a>
                    })}
                    <СitiesCloseBtn closeMenu={closeMenu} />
                </div>
            }
        </div >
    )
}

export default Country